import React, { forwardRef } from "react";
import moment from "moment";
import { DatePickerStyled } from "./elements";
import format from "../../../constants/format";

export type Props = {
  onChange?: (date: any, dateString: string) => void;
  placeholder?: string;
  width?: string;
  picker?: "month";
  value?: moment.Moment | null;
  disabled?: boolean;
  disabledDate?: ((date: any) => boolean) | null;
  getPopupContainer?: any;
  onOpenChange?: (open: boolean) => void;
  dropdownClassName?: string;
  style?: React.CSSProperties;
  onMouseDown?: React.MouseEventHandler<HTMLDivElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  showTime?: boolean;
  formatProp?: string;
  onOk?: any;
  name?: string;
  open?: boolean;
};

const defaultDisabledDate = (currentDate: any) => {
  return !currentDate || currentDate.isAfter(Date.now());
};

const DatePicker = (props: Props, ref: any) => {
  const {
    picker,
    value,
    disabled,
    disabledDate,
    getPopupContainer,
    placeholder = "Date",
    onOpenChange,
    dropdownClassName,
    style,
    onBlur,
    formatProp,
    open,
  } = props;

  return (
    <>
      {picker === "month" ? (
        <DatePickerStyled
          {...props}
          format={formatProp || format.monthFormat}
          disabledDate={disabledDate || defaultDisabledDate}
          value={value ? moment(value) : null}
          disabled={disabled || false}
          ref={ref}
          getPopupContainer={getPopupContainer}
          onOpenChange={onOpenChange}
          style={style}
          onBlur={onBlur}
          open={open}
        />
      ) : (
        <DatePickerStyled
          {...props}
          placeholder={placeholder}
          format={formatProp || format.dateFormat}
          disabledDate={disabledDate || defaultDisabledDate}
          value={value ? moment(value) : null}
          disabled={disabled || false}
          ref={ref}
          getPopupContainer={getPopupContainer}
          dropdownClassName={dropdownClassName}
          onOpenChange={onOpenChange}
          style={style}
          onBlur={onBlur}
          open={open}
        />
      )}
    </>
  );
};

export default forwardRef(DatePicker);
